var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "anticon",
    color: "currentColor",
    height: 16,
    viewBox: "0 0 1024 1024",
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    fill: "none",
    r: 426,
    stroke: "transparent",
    strokeWidth: 72
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    height: 252,
    rx: 24,
    ry: 24,
    width: 252,
    x: 386,
    y: 386
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.667 512C938.667 276.359 747.64 85.333 512 85.333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 73
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "1s",
    from: "0 512 512",
    repeatCount: "indefinite",
    to: "360 512 512",
    type: "rotate"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatLoader);
export default __webpack_public_path__ + "static/media/chat-loader.9e462f29a7c453a0e7cba64d95d5a807.svg";
export { ForwardRef as ReactComponent };